var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { Observable, Subject, combineLatest } from 'rxjs';
import { ViewService } from '../../view.service';
import { takeUntil } from 'rxjs/operators';
var ViewChaptersComponent = /** @class */ (function () {
    // ---------- Lifecycle ----------
    function ViewChaptersComponent(store, viewService, changeDetectorRef) {
        this.store = store;
        this.viewService = viewService;
        this.changeDetectorRef = changeDetectorRef;
        // ---------- Inputs ----------
        this.showHeader = true;
        this.showList = true;
        this.defaultImage = '/assets/images/view-chapter-thumbnail-placeholder.png';
        // ---------- Class Variables ----------
        this.ngUnsubscribe = new Subject();
        this.nextChapter = null;
    }
    ViewChaptersComponent.prototype.ngOnInit = function () {
        this.initChaptersObserver();
    };
    ViewChaptersComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    // ---------- Observers ----------
    ViewChaptersComponent.prototype.initChaptersObserver = function () {
        var _this = this;
        combineLatest([
            this.store.select(StoryChaptersState.getStoryChapters),
            this.store.select(StoryChaptersState.getSelectedChapterIndex)
        ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (_a) {
            var _b = __read(_a, 2), chapters = _b[0], index = _b[1];
            var nextIndex = index + 1;
            _this.nextChapter = (nextIndex >= chapters.length) ? null : chapters[nextIndex];
            _this.changeDetectorRef.markForCheck();
        });
    };
    // ---------- Interaction ----------
    ViewChaptersComponent.prototype.handleChapterClick = function (chapter) {
        this.viewService.selectChapter(chapter);
    };
    ViewChaptersComponent.prototype.handleNextChapterClick = function () {
        this.viewService.nextChapter();
    };
    ViewChaptersComponent.prototype.handleToggleList = function () {
        this.showList = !this.showList;
    };
    // ---------- Utility ----------
    ViewChaptersComponent.prototype.getChapterThumb = function (chapterId) {
        var thumbnails = this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
        var thumbnail = thumbnails.get(chapterId);
        // use snapshot if present, otherwise use small
        if (!!thumbnail) {
            return thumbnail.snapshot || thumbnail.urls.small;
        }
        else {
            return '';
        }
    };
    __decorate([
        Select(StoryChaptersState.getStoryChapters),
        __metadata("design:type", Observable)
    ], ViewChaptersComponent.prototype, "chapters$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterId),
        __metadata("design:type", Observable)
    ], ViewChaptersComponent.prototype, "selectedChapterId$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterIndex),
        __metadata("design:type", Observable)
    ], ViewChaptersComponent.prototype, "selectedChapterIndex$", void 0);
    __decorate([
        Select(StoryChaptersState.getRegisteredThumbnails),
        __metadata("design:type", Map)
    ], ViewChaptersComponent.prototype, "thumbnails$", void 0);
    return ViewChaptersComponent;
}());
export { ViewChaptersComponent };
